/* eslint-disable
    @typescript-eslint/no-this-alias,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics } from '@trello/atlassian-analytics';
import { Auth } from 'app/scripts/db/auth';
import CreateOrgView from 'app/scripts/views/organization/create-org-view';
import { featureFlagClient } from '@trello/feature-flag-client';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import { templates } from 'app/scripts/views/internal/templates';

class NewBoardHelperAddOrgView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'add an organization';

    this.prototype.events = { 'click .js-create-org': 'newOrg' };
  }

  render() {
    this.$el.html(
      templates.fill(
        require('app/scripts/views/templates/popover_helper_new_board_add_org'),
      ),
    );

    if (featureFlagClient.get('dataeng.gasv3-event-tracking', false)) {
      Analytics.sendScreenEvent({
        name: 'newBoardHelperAddWorkspaceInlineDialog',
      });
    }
    return this;
  }

  newOrg(e) {
    const createOpts = {};

    if (Auth.me().isPaidManagedEntMember()) {
      createOpts.isEnterprise = true;
    }

    stopPropagationAndPreventDefault(e);
    const trackingOpts = {
      category: 'board',
      method: 'by clicking team info icon in copy board menu',
    };
    return PopOver.pushView({
      view: new CreateOrgView({
        model: this.model,
        modelCache: this.modelCache,
        createOpts,
        trackingOpts,
      }),
    });
  }
}

NewBoardHelperAddOrgView.initClass();
export { NewBoardHelperAddOrgView };
